import React from "react";
import { Icon } from "@vitalsource/vstui";
import { cloud } from "@vitalsource/vstui/colors";

const MarginMedium = () => (
  <Icon width={76} height={52}>
    <rect width="40" height="40" x="18" y="6" fill={cloud.getShade(5)} />
  </Icon>
);

export default MarginMedium;
